const PrivateSections = [
    {
        title: 'Introduction',
        content: (
            <p>Welcome to AEMR4All. We are committed to protecting your privacy and ensuring transparency in how we collect, use, and protect your information. This Privacy Policy outlines the types of information we collect and how it is used.</p>
        )
    },
    {
        title: 'Information We Collect',
        content: (
            <>
                <p>To provide access to our platform, we collect minimal user information, including:</p>
                <ul>
                    <li>Name</li>
                    <li>Affiliation (institution or organization)</li>
                    <li>Program (e.g., major, specialty, etc.)</li>
                    <li>Contact information (email address)</li>
                    <li>Purpose of use</li>
                </ul>
                <p>We do not collect sensitive personal information or patient data.</p>
            </>
        )
    },
    {
        title: 'How We Use Your Information',
        content: (
            <>
                <p>The information collected is used solely to:</p>
                <ul>
                    <li>Understand our user base and request a user survey to improve the platform</li>
                    <li>Ensure responsible use of AEMR4All</li>
                    <li>Communicate important updates or changes related to the platform</li>
                </ul>
                <p>We do <b>not</b> share, sell, or distribute user information to third parties.</p>
            </>
        )
    },
    {
        title: 'Data Security',
        content: (
            <p>AEMR4All operates on <b>Google Sheets</b>, and while we take reasonable steps to protect user
                information, we encourage users to follow best practices for data security. Users are responsible for ensuring they do not input real patient data into the system.</p>
        )
    },
    {
        title: 'User Responsibilities',
        content: (
            <ul>
                <li>The platform is for educational purposes <b>only</b> and must not be used for actual clinical documentation.</li>
                <li>Users must not enter, store, or share <b>real</b> patient data.</li>
                <li>Any misuse of the platform may result in access being revoked.</li>
            </ul>
        )
    },
    {
        title: 'How we handle your data',
        content: (
            <>
                <p>We collect and store certain user data obtained through your Google account solely to provide and improve our services. This includes information such as your name, and email address.</p>
            </>

        )
    },
    {
        title: 'Data Retention',
        content: (
            <>
                <p>We retain your Google user data only for as long as necessary to provide the functionality of our services or as required by applicable law. If your account remains inactive for a prolonged period (e.g., 12 months), we may delete your stored data after prior notice.</p>
            </>

        )
    },
    {
        title: 'Data Deletion',
        content: (
            <>
                <p>You may request deletion of your Google user data at any time by:</p>
                <ul>
                    <li>Contacting us directly at aemr4all@gmail.com</li>
                </ul>
                <p>Once a deletion request is received, all associated Google user data will be permanently deleted from our systems within 30 days, except where we are required to retain certain information for legal or compliance reasons.</p>
            </>

        )
    },
    {
        title: 'Changes to This Policy',
        content: (
            <p>We may update this Privacy Policy as needed. Any changes will be posted on our website.</p>
        )
    },
    {
        title: 'Contact Us',
        content: (
            <p>For any questions regarding this Privacy Policy, please contact us at <a
                href="mailto:aemr4all@gmail.com">aemr4all@gmail.com</a></p>
        )
    },
];

export default PrivateSections;